import { cancelModuleTemplate, deleteModuleTemplate, loadModuleTemplates, saveModuleTemplate } from '@/api/moduleTemplate';
import { addComment, changeComment } from '@/utils/comment';
import ListClass from './ListClass';

type IModuleTemplateInfo = IModule.IResponse.IModuleTemplateInfo;
type IModuleTemplateParams = IModule.IRequest.IModuleTemplateParams;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

export default class ModuleTemplateListClass {
  public list: ListClass<IModuleTemplateInfo>;
  private $editItem: IModuleTemplateInfo | undefined = undefined;
  private $moduleTemplate: IModuleTemplateInfo | undefined = undefined;
  get editItem() {
    return this.$editItem;
  }
  get moduleTemplate() {
    return this.$moduleTemplate;
  }
  constructor() {
    this.list = new ListClass();
  }
  public requestLoadTemplates(): Promise<string> {
    return new Promise((reslove, reject) => {
      loadModuleTemplates().then((res) => {
        this.list.initData(res.data);
        reslove(res.message);
      }).catch((error) => {
        reject(error.message);
      });
    });
  }
  public saveTemplate(templateData: IModuleTemplateParams): Promise<string> {
    return new Promise((reslove, reject) => {
      saveModuleTemplate(templateData).then((res) => {
        this.requestLoadTemplates();
        reslove(res.message);
      }).catch((e) => {
        reject(e.message);
      });
    });
  }
  public requestUpdateTemplate(templateData: IModuleTemplateParams): Promise<string> {
    return new Promise((reslove, reject) => {
      saveModuleTemplate(templateData).then((res) => {
        this.updateTemplate(templateData);
        reslove(res.message);
      }).catch((e) => {
        reject(e.message);
      });
    });
  }
  public cancelTemplate(templateId: string): Promise<string> {
    return new Promise((reslove, reject) => {
      cancelModuleTemplate(templateId).then((res) => {
        const template = this.list.findItemById(templateId);
        if (template) {
          template.status = 'Cancel';
        }
        reslove(res.message);
      }).catch((e) => {
        reject(e.message);
      });
    });
  }
  public deleteTemplate(templateId: string): Promise<string> {
    return new Promise((reslove, reject) => {
      deleteModuleTemplate(templateId).then((res) => {
        this.list.deleteItemById(templateId);
        reslove(res.message);
      }).catch((e) => {
        reject(e.message);
      });
    });
  }
  public changeEditItem(item: IModuleTemplateInfo) {
    this.$editItem = item;
  }
  public changeModuleParams(template: IModuleTemplateInfo) {
    this.$moduleTemplate = template;
  }
  public updateComment(
    type: 'ADD' | 'CHANGE',
    listItem: IModuleTemplateInfo,
    comment: ICreateOrUpdateComment,
  ) {
    if (type === 'ADD') {
      listItem.comments = addComment(listItem.comments, comment);
      return;
    }
    listItem.comments = changeComment(listItem.comments, comment);
  }
  public updateTemplate(templateData: IModuleTemplateParams) {
    const {comment, templateContent} = templateData;
    const newTemplate = this.list.findItemById(templateData.id);
    if (newTemplate) {
      this.list.updateItem({
        ...newTemplate,
        comment,
        moduleTitle: templateContent.title,
        templateTodoList: templateContent.templateTodoList,
      });
    }
  }
}
export const templateListInstance = new ModuleTemplateListClass();
